import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import download from "../../../helpers/download";
import { getRptPtosPanorama } from "./services";

const initialState: any = {
  status: "",
  noContent: true
};

export const actionGetRptPtosPanorama: any = createAsyncThunk<any, any>(
  "ACTION_GET_RPTPTS_PANORAMA_BY_LOJA",
  async (reportType, { getState }: any) => {
    const {
      getLojas: { lojaSelected, lojaSelectedInfos: {nome} },
    } = getState();
    
    const result = await getRptPtosPanorama({ idLoja: lojaSelected, reportType });
    
    download(result, {ext: reportType, fileName: `relatorio-${nome}`});

    return result
  }
);

const sliceGetRptPtosPanorama = createSlice({
  name: "GET_RPTPTOSPANORAMA",
  initialState,
  reducers: {},
  extraReducers: {
    [actionGetRptPtosPanorama.pending]: (state) => {
      state.status = "loading";
    },
    [actionGetRptPtosPanorama.fulfilled]: (state, { payload: { status } }) => {
      state.status = "success";
      state.noContent = status === 204;
    },
    [actionGetRptPtosPanorama.rejected]: (state) => {
      state.status = "error";
    },
  },
});

export default sliceGetRptPtosPanorama.reducer
